module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column start-centered indicativo-container"
  }, [_c('div', [_vm._v("Indique a agência de abertura de conta para movimentação dos recursos do Projeto:")]), _vm._v(" "), (!this.gravando) ? _c('div', {
    staticClass: "column start-centered indicativo-agencia-container"
  }, [_c('div', {
    staticClass: "row-flex centered-start indicativo-form"
  }, [_c('label', {
    staticClass: "control-label indicativo-label f-required",
    attrs: {
      "for": "título do curso"
    }
  }, [_vm._v("Agência:")]), _vm._v(" "), _c('the-mask', {
    staticClass: "form-control indicativo-input",
    attrs: {
      "mask": '####',
      "name": "título do curso",
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.digitandoAgencia()
      }
    },
    model: {
      value: (_vm.consultaAgencia),
      callback: function($$v) {
        _vm.consultaAgencia = $$v
      },
      expression: "consultaAgencia"
    }
  })], 1), _vm._v(" "), (this.consultando) ? _c('div', [_c('i', {
    staticClass: "fa fa-refresh fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (!this.consultando && this.agenciaSelecionada.nomeAgencia !== '') ? _c('div', {
    staticClass: "column start-centered indicativo-info-container"
  }, [_c('div', {
    staticClass: "row start-centered"
  }, [_c('label', [_vm._v("Número: ")]), _vm._v(" " + _vm._s(this.agenciaSelecionada.agencia) + "\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "row start-centered"
  }, [_c('label', [_vm._v("Nome: ")]), _vm._v(" " + _vm._s(this.agenciaSelecionada.nomeAgencia) + "\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "row start-centered"
  }, [_c('label', [_vm._v("E-mail: ")]), _vm._v(" " + _vm._s(this.agenciaSelecionada.emailAgencia) + "\n         ")])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b66ce63a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/agenciaIndicativaContaProjeto.vue
// module id = 2061
// module chunks = 1